module.exports = __webpack_public_path__ + "assets/img/profile-npc.33db02a1.svg";